import { memo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Space } from 'antd';
import { dateToString, getFullName } from '@/utils';
import { useGetChildPlacementsQuery } from '@/services/child-api';
import Table from '@/components/table';

const columns = [
  {
    title: 'Parents',
    dataIndex: 'parents',
    render: (value, record) => (
      <Space direction="vertical" size={0}>
        {value.map((item) => (
          <Link key={item.individualParentId} to={`/parent/${record.parentId}`}>
            {getFullName(item)}
          </Link>
        ))}
      </Space>
    ),
  },
  {
    title: 'Matched Date',
    dataIndex: 'matchedDate',
    render: (value) => dateToString(value),
  },
  {
    title: 'Placed Date',
    dataIndex: 'placedDate',
    render: (value) => dateToString(value),
  },
  {
    title: 'Removed Date',
    dataIndex: 'removeDate',
    render: (value) => dateToString(value),
  },
  {
    title: 'Note',
    dataIndex: 'note',
    ellipsis: true,
  },
];

const PlacementHistory = ({ childId }) => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const pageNumber = queryParams.get('page') || 1;
  const { data, isFetching } = useGetChildPlacementsQuery({ childId, pageNumber });

  return (
    <Table
      columns={columns}
      dataSource={data?.data}
      rowKey="childPlacementId"
      loading={isFetching}
      pageInfo={data}
      size="small"
    />
  );
};

export default memo(PlacementHistory);
